<div [fxLayout]="layout" fxLayoutGap="0.714rem" [fxLayoutAlign]="layoutAlignment">
  <div *ngIf="label">{{ label }}</div>
  <div [fxLayout]="contentLayout" [fxLayoutAlign]="contentLayoutAlignment">
    <ng-content></ng-content>
  </div>
</div>
